import { z } from "zod";
/** Müşteri profilinin durumu (`customer_profiles.status`). Anonimleştirilen kayıt silinmez (ADR 0017 §4). */
export const CUSTOMER_STATUSES = ["ACTIVE", "INACTIVE", "ANONYMIZED"];
export const customerStatusSchema = z.enum(CUSTOMER_STATUSES);
export const CUSTOMER_STATUS_LABELS = {
    ACTIVE: "Etkin",
    INACTIVE: "Pasif",
    ANONYMIZED: "Anonimleştirildi",
};
/** Kaydın açıldığı kanal (`customer_profiles.created_via`). */
export const CUSTOMER_CREATED_VIA = ["STATION", "POS", "WEB", "DRIVER_APP", "IMPORT"];
export const customerCreatedViaSchema = z.enum(CUSTOMER_CREATED_VIA);
/** Şarj soketi türü (`vehicles.connector_type`). */
export const VEHICLE_CONNECTOR_TYPES = ["TYPE1", "TYPE2", "CCS2", "CHADEMO", "GBT", "OTHER"];
export const vehicleConnectorTypeSchema = z.enum(VEHICLE_CONNECTOR_TYPES);
export const VEHICLE_CONNECTOR_TYPE_LABELS = {
    TYPE1: "Type 1",
    TYPE2: "Type 2",
    CCS2: "CCS2",
    CHADEMO: "CHAdeMO",
    GBT: "GB/T",
    OTHER: "Diğer",
};
//# sourceMappingURL=enums.js.map